import * as v from "valibot";

import { rpcContract } from "../rpc";

export const socialLinksRpcContract = rpcContract({
  name: "socialLinks",
  paramsSchema: v.undefined(),
  resultSchema: v.object({
    links: v.array(v.string()),
  }),
});

export type SocialLinksParams = v.InferOutput<(typeof socialLinksRpcContract)["paramsSchema"]>;

export type SocialLinksResult = v.InferOutput<(typeof socialLinksRpcContract)["resultSchema"]>;
